import React from "react";

function Icon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 24 24"
      color={color}
      fill="currentColor"
      width="24"
      height="24"
    >
      <path
        fillRule="nonzero"
        d="M9.001 13.022H5.75a.751.751 0 00-.544 1.27l6.069 6.396a.998.998 0 001.45 0l6.068-6.396a.752.752 0 00-.543-1.27h-3.251v-9.02c0-.531-.47-1.002-1-1.002h-3.998c-.53 0-1 .471-1 1.002z"
      ></path>
    </svg>
  );
}

export default Icon;
